export interface FeeBreakdownItemResponse {
  feeId: number;

  feeCode?: string;

  /* The amount of money for this order associated with this fee. */
  amount: number;

  /* At what level this fee is applied. Only makes sense with value type AMOUNT as percentage fees will be the same regardless of weather they are applied at transaction or token level */
  applicationLevel?: ApplicationLevel;

  /* The name of this fee */
  name: string;

  /* The reason this fee is applied. Allows special UI to show up explaining each fee. */
  reason?: Reason;

  /* At what level this fee is applied. Only makes sense with value type AMOUNT as percentage fees will be the same regardless of weather they are applied at transaction or token level */
  responsibilityType?: ResponsibilityType;

  /* The value associated with this fee. Should be used alongside valueType. For example for a 10% fee, the value will be 10 and the value type will be PERCENT. */
  value: number;

  /* The type of value. Used to distinguish between percentage fees and fixed amount fees */
  valueType: ValueType;

  /* The optional long name of this fee */
  nameLong?: string;

  /* If the fee was included in base */
  includedInBase?: boolean;

  breakdownDisplayOption?: BreakdownDisplayOption;

  externalTax?: boolean;
}

export interface DiscountBreakdownItemResponse {
  discountId: number;
  name: string;
  advertisementString: string;
  requirementMissingMessage: string;
}

/**
 * This is a server model and should only be used on the server boundary, not
 * in the client code. See `TokenFee` in `@yoop/whitelabel-data`.
 */
export interface BreakdownItemResponse {
  amount: number;
  name: string;
  breakdownType: BreakdownType;
  feeResponse?: FeeBreakdownItemResponse;
  discountResponse?: DiscountBreakdownItemResponse;
}

export enum BreakdownType {
  DISCOUNT = 'DISCOUNT',
  FEE = 'FEE',
}

export enum ValueType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  PROFIT_PERCENTAGE = 'PROFIT_PERCENTAGE',
  STEPPED = 'STEPPED',
  TBD = 'TBD',
}

export enum ApplicationLevel {
  TOKEN = 'TOKEN',
  TRANSACTION = 'TRANSACTION',
  PREVIOUS_FEE = 'PREVIOUS_FEE',
  PREVIOUS_FEE_TOKEN = 'PREVIOUS_FEE_TOKEN',
  TOKEN_PROFIT = 'TOKEN_PROFIT',
}

export enum CustomFeeApplicationRule {
  NONE = 'NONE',
  ALL = 'ALL',
  ONLY_TAXABLE = 'ONLY_TAXABLE',
}

export enum ResponsibilityType {
  CLIENT = 'CLIENT',
  BUYER = 'BUYER',
  SELLER = 'SELLER',
}

export enum Reason {
  PAYMENT = 'PAYMENT',
  PROFIT_SHARE = 'PROFIT_SHARE',
  TAX = 'TAX',
  YOOP = 'YOOP',
  ORGANIZER_CUT = 'ORGANIZER_CUT',
  CUSTOM = 'CUSTOM',
}

export enum BreakdownDisplayOption {
  ALL = 'ALL',
  EMAIL = 'EMAIL',
}
